namespace Roodik.Core
{
	export class GameDistributionAd extends Advertisment
	{
		private _available:boolean = false;
		private _adPauseTime:number = 60000;
		private _adRequested:boolean = false;
		private _lastShowedTime:number = Date.now();

		constructor(config:IAdvertismentConfig)
		{
			super();

			window["GD_OPTIONS"] = {
				"debug": config.debug, // Enable debugging console. This will set a value in local storage as well, remove this value if you don't want debugging at all. You can also call it by running gdsdk.openConsole() within your browser console.
				"gameId": config.id, // Your gameId which is unique for each one of your games; can be found at your Gamedistribution.com account.
				"advertisementSettings": {
					"debug": config.debug, // Enable IMA SDK debugging.
					"autoplay": false,
					"locale": "en"
				},
				"onEvent": this.parseResponse.bind(this),
			};

			var script = document.createElement('script');
			document.getElementsByTagName('body')[0].appendChild(script);
			this.create(document, 'script', 'gamedistribution-jssdk');
		}

		private parseResponse(event)
		{
			switch (event.name) {
				case "SDK_GAME_START":
					this._adRequested = false;
					this._resumeGameEvent.invoke();
					break;
				case "SDK_GAME_PAUSE":
					this._pauseGameEvent.invoke();
					break;
				case "SDK_READY":
					this._adRequested = false;
					this._available = true;
					break;
				case "SDK_ERROR":
					this._adRequested = false;
					this._available = false;
					break;
				case "SDK_GDPR_TRACKING":
					// ..
					break;
				case "SDK_GDPR_TARGETING":
					// ..
					break;
				case "SDK_GDPR_THIRD_PARTY":
					// ..
					break;
			}
		}

		private create(d, s, id) {
			var js, fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) return;
			js = d.createElement(s);
			js.id = id;
			js.src = 'https://html5.api.gamedistribution.com/main.min.js';
			fjs.parentNode.insertBefore(js, fjs);
		}

		public fetch()
		{
		}

		public show(force:boolean)
		{
			if (this.available)
			{
				let timeLeft = Date.now() - this._lastShowedTime;
				// console.log("---> this._lastShowedTime = ",this._lastShowedTime);
				// console.log("---> timeLeft = ",timeLeft);
				if (force || timeLeft >= this._adPauseTime)
				{
					if (!this._adRequested)
					{
						// console.log("SHOW AD");
						this._lastShowedTime = Date.now();
						this._adRequested = true;
						window["gdsdk"].showBanner();
					}
					else
					{
						this._resumeGameEvent.invoke();
					}
				}
				else
				{
					this._resumeGameEvent.invoke();
				}
			}
		}

		private get sdkExist():boolean
		{
			return window["gdsdk"] !== 'undefined' && window["gdsdk"] != null && window["gdsdk"].showBanner !== 'undefined';
		}

		public get available():boolean
		{
			return this.sdkExist && this._available;
		}

	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Advertisment/GameDistributionAd.ts